<template>
    <div component="OrderView">
        <v-row class="column-wrapper">
            <v-col cols="4" class="left-column">
                <character-list :can-edit="false" />
            </v-col>

            <v-col cols="8" class="right-column">
                <order />
            </v-col>
        </v-row>
    </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import CharacterList from '@/components/Project/Character/CharacterList.vue';
import Order from '@/components/Project/Order/Order';

export default {
    name: 'OrderView',

    data() {
        return {};
    },

    async created() {
        await this.loadProjectEssentials();
    },

    async mounted() {},

    methods: {
        ...mapActions(['loadProjectEssentials']),
        ...mapMutations([]),
    },

    computed: {
        ...mapGetters([]),
    },

    watch: {},

    components: {
        Order,
        CharacterList,
    },
};
</script>

<style lang="less">
@import '~@variables';

[component='OrderView'] {
    .column-wrapper {
        margin: 0;
        flex-wrap: nowrap;
        flex: auto;
        height: auto;
    }

    .left-column {
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
    }

    .right-column {
        min-width: 510px;
        overflow-x: auto;
        font-size: 0.8rem;
    }
}
</style>
